<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="30%"
      title="场地区域"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="courseForm">
        <el-form-item label="沙龙主题" prop="title">
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="活动类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :required="true"
          label="报名开始时间"
          style="margin-bottom: 30px"
          prop="start_time">
          <el-date-picker
            v-model="form.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :required="true" label="报名结束时间" prop="end_time">
          <el-date-picker
            v-model="form.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="城市">
          <el-cascader
            v-model="cityList"
            :options="cityoptions"
            :props="cityProps"
            placeholder="城市"
            @change="cityChange"
          ></el-cascader>
        </el-form-item>
        <!-- <el-form-item label="活动地址">
          <el-input v-model="form.address"></el-input>
        </el-form-item> -->
        <el-form-item label="活动说明">
          <el-input
            type="textarea"
            placeholder="活动时间,活动内容等；不同内容之间换行"
            v-model="form.context"
            :autosize="{ minRows: 2, maxRows: 8 }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="主题图" required>
          <avatar-uploader
            @getImgUrl="(v) => (form.face_url = v)"
            :url="form.face_url"
          ></avatar-uploader>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { typeList } from "../dict.js";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      typeList,
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      if_clear: true,
      count: 1,
      cityList: [],
      cityoptions: [],
      cityProps: {
        value: "district",
        label: "district",
        children: "childrens",
      },
    };
  },

  mounted() {
    this.cityoptions = JSON.parse(localStorage.getItem("addrList"));
  },

  methods: {
    cityChange(v) {
      this.form.province = v[0];
      this.form.city = v[1];
      this.form.district = v[2];
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.cityList = [
          this.form.province,
          this.form.city,
          this.form.district,
        ];
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
        this.cityList = [];
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/salonActivity/insert";

      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      if(Object.values(data).length == 0){
        return
      }
      data.id = this.form.id;
      let url = "/user/salonActivity/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>